const supportOptions = {
  employeeHelpdesk: {
    header: 'Contact us using one of these methods',
    subHeader: 'Cast & Crew',
    email: 'employeehelpdesk@castandcrew.com',
    phone: {
      name: '888.570.4650',
      number: '(888) 570-4650',
    },
    subHeader2: 'Media Services',
    email2: 'crewportalhelp@mediaservices.com',
    phone2: {
      name: '310.254.1702',
      number: '(310) 254-1702',
    },
  },
  taxSupport: {
    header: 'Contact us using the info below',
    email: 'payroll_tax@castandcrew.com',
  },
  taxCapsSupport: {
    header: 'Contact us using the info below',
    email: 'tax@capspayroll.com',
  },
  employementVerificationPdf: {
    header: 'Read the document below for instructions',
    url: {
      address:
        'https://www.castandcrew.com/forms-and-resources/employment-income-verification/',
      name: 'How to Use The Work Number to Verify Employment',
    },
  },
  infoVancouver: {
    header: 'Contact us using one of these methods',
    email: 'info_vancouver@castandcrew.com',
    // TODO check area codes format for CAN
    phone: {
      name: '604.437.6363',
      number: '(604) 437-6363',
    },
  },
  infoToronto: {
    header: 'Contact us using one of these methods',
    email: 'info_toronto@castandcrew.com',
    phone: {
      name: '416.406.2768',
      number: '(416) 406-2768',
    },
  },
  CnCSupport: {
    header: 'Contact us using one of these methods',
    email: 'plus.support@castandcrew.com',
    phone: {
      name: '818.860.7770',
      number: '(818) 860-7770',
    },
    url: {
      address: 'https://my.castandcrew.com/support',
      name: 'Contact Form',
    },
  },
  CnCCanSupport: {
    header: 'Contact us using one of these methods',
    email: 'plus.support@castandcrew.com',
    phone: {
      name: '416.324.9748',
      number: '(416) 324-9748',
    },
    url: {
      address: 'https://my.castandcrew.com/support',
      name: 'Contact Form',
    },
  },
  capsSupport: {
    header: 'Contact us using one of these methods',
    email: 'etcsupport@castandcrew.com',
    phone: {
      name: '818.480.4400',
      number: '(818) 480-4400',
    },
  },
  plusSupport: {
    header: 'Contact us using one of these methods',
    email: 'plus.support@castandcrew.com',
    phone: {
      name: '818.860.7770 - Option #1',
      // Using a 'p' introduces a 1-sec pause for extensions
      number: '(818) 860-7770p1',
    },
  },
  canPlusSupport: {
    header: 'Contact us using one of these methods',
    email: 'plus.support@castandcrew.com',
    phone: {
      name: '416.324.9748 - Option #1',
      number: '(416) 324-9748p1',
    },
  },
};

const supportDetailsSelector = (formData, isCanada = false) => {
  if (formData.product === 'Cast & Crew')
    return isCanada ? supportOptions.CnCCanSupport : supportOptions.CnCSupport;
  if (formData.product === 'CAPS / ETC (US only)')
    return supportOptions.capsSupport;
  if (formData.product === 'I don’t know')
    return isCanada
      ? supportOptions.canPlusSupport
      : supportOptions.plusSupport;
  if (formData.region === 'US')
    return supportOptions.employementVerificationPdf;
  if (formData.region === 'Vancouver') return supportOptions.infoVancouver;
  if (formData.region === 'Toronto') return supportOptions.infoToronto;
  if (
    formData.topic === 'Profile or Direct Deposit' ||
    formData.topic === 'Pay Stubs' ||
    formData.topic === 'Loan-outs'
  )
    return supportOptions.employeeHelpdesk;
  if (formData.topic === 'W-4 / TD-1 Tax Withholding')
    return supportOptions.employeeHelpdesk;
  if (formData.year === 'Tax year 2018 or later')
    return supportOptions.employeeHelpdesk;
  if (formData.source === 'Cast & Crew') return supportOptions.taxSupport;
  if (formData.source === 'CAPS or PAI') return supportOptions.taxCapsSupport;
  if (formData.source === 'I don’t know') return supportOptions.taxSupport;
  return {};
};

export default supportDetailsSelector;
